// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3Z4hy","content":"LayoutSettings_content__12MNZ"};